export default {
  name: 'rankOptions',
  template: '#rank-options-template',
  props: [
    'isYou',
    'rankName',
    'showRanks'
  ],
  data () {
    return {
    }
  },
  methods: {
    selectRank (rankOptionsIdx) {
      this.$emit('select-rank', rankOptionsIdx)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/assemble/team/RankOptions.js